import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import SportService from 'services/SportService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    sportData: [],
    singleSport:[],
    data:[],
}


export const getSport = createAsyncThunk('sport/getSport', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SportService.getSport(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const createSport = createAsyncThunk('sport/createSport', async (data, { rejectWithValue }) => {
	
	try {
		const response = await SportService.createSport(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const updateSport = createAsyncThunk('sport/updateSport', async (data, { rejectWithValue }) => {
	
	try {
		const response = await SportService.updateSport(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})



export const sportSlice = createSlice({
    name: 'sport',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getSport.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getSport.fulfilled, (state, action) => {
            state.loading = false
            state.sportData = action.payload
        })
        .addCase(getSport.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(createSport.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(createSport.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Sport Added"
        })
        .addCase(createSport.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(updateSport.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(updateSport.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Sport Updated"
        })
        .addCase(updateSport.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
       
    }
});


export default sportSlice.reducer;